const styles = {
  root: {},

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center'
  },

  subtitle: {
    fontFamily: "'Montserrat', sans-serif",
    color: 'rgba(0,0,0,0.5)'
  },

  paper: {
    width: '100%',
    padding: 30,
    overflowX: 'auto'
  },

  impactCircle: {
    width: 250,
    height: 250,
    borderRadius: 125,
    backgroundColor: '#b1b3b5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 30
  },

  logoImage: {
    width: 80
  },

  mealCountText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  countingText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  backButton: {
    cursor: 'pointer',
    color: '#122B4F',
    fontFamily: "'Montserrat', sans-serif",
    fontWeight: 'bold',
    position: 'absolute',
    top: 90,
    left: 20
  },

  tableWrapper: {},

  table: {
    minWidth: 700
  },

  tablePagination: {
    background: '#fff'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/donations/styles.js